// extracted by mini-css-extract-plugin
module.exports = {"vendorListWrapper":"_1kEPLQUdD_WSDEG72HGLmK","vendorListItemWrapper":"_3KT9Mx4pMgv1I10ZluF3UC"};